import { useCallback } from 'react';

import { useTkv2UpdateReferenceBarProperties } from '../../../controller/hooks/useTkv2UpdateReferenceBarProperties.ts';
import { selectReferenceBarUI } from '../../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { formatReferenceViewID } from '../referenceViewID/formatReferenceViewID.ts';
import { parseReferenceViewID } from '../referenceViewID/parseReferenceViewID.ts';
import { ReferenceViewIDParsed } from '../referenceViewID/types.ts';
import { Feature } from './types.ts';

export const useHandlePinClick = () => {
  const { properties: refBarProperties } = useAppSelector(selectReferenceBarUI);
  const updateRefBarProperties = useTkv2UpdateReferenceBarProperties();

  return useCallback(
    (feature?: Feature) => {
      const pinIsAlreadySelected =
        refBarProperties.filter((prop) => {
          const parsedID = parseReferenceViewID(prop.id) as {
            type: 'comparable';
            compID?: string;
          };
          return feature?.properties.id && parsedID.compID === feature.properties.id;
        }).length > 0;

      if (pinIsAlreadySelected) {
        formatReferenceViewID({ type: 'subject' });
        updateRefBarProperties({
          id: formatReferenceViewID({ type: 'subject' }),
          mapPinLabel: '',
        });

        return;
      }

      const refViewID: ReferenceViewIDParsed =
        feature?.properties.id === 'subject'
          ? {
              type: 'subject',
            }
          : {
              type: 'comparable',
              compID: feature?.properties.id ?? '',
            };

      updateRefBarProperties({
        id: formatReferenceViewID(refViewID),
        mapPinLabel: feature?.properties.idx?.toString() ?? '',
      });
    },
    [refBarProperties, updateRefBarProperties],
  );
};
